import axios from "axios";

export const loginUser = async (data, customdomain) => {
  const url = `${process.env.REACT_APP_APIURL}/vendor/login`;

  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  if (customdomain !== "aitech.com.sa") {
    headers.domain_name = customdomain;
  }

  const response = await axios.post(url, JSON.stringify(data), {
    headers,
  });

  return response.data;
};
